"use client"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"

interface SettingsCardProps {
  title: string
  description: string
  onEdit: () => void
}

export default function SettingsCard({ title, description, onEdit }: SettingsCardProps) {
  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardHeader>
        <CardTitle className="text-lg">{title}</CardTitle>
        <CardDescription className="text-sm">{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button onClick={onEdit} className="w-full">
          Edit Settings
        </Button>
      </CardContent>
    </Card>
  )
}
